// Ratio
const ratio = [
    { key: '1-1', value: 1 / 1, title: '1x1' },
    { key: '1-2', value: 2 / 1, title: '1x2' },
    { key: '2-1', value: 1 / 2, title: '2x1' }
];
exports.ratio = ratio;
